module.exports = __webpack_public_path__ + "12.png?911c436613cad613dca3d90f18b78355";


//////////////////
// WEBPACK FOOTER
// ./src/assets/screenshots/12.png
// module id = 126
// module chunks = 3